import cartodb from "@/constants/cartodb.js";
import cartoDB from "@/helpers/cartoDB";
import {removeGeoJsonLayer, setMapViewBounds, showGeoJSONData} from "./HereMap";

const {cartoTable} = cartodb;

function fitBoundGeoJson(cartodbIds) {
	cartoDB
		.executeQueryWithBounds(
			`WITH bbox as (SELECT ST_Envelope(the_geom) as the_geom FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}))
                                    SELECT the_geom, ST_Xmax(the_geom) as xmax,
                                    ST_Ymax(the_geom) as ymax,
                                    ST_Xmin(the_geom) as  xmin,
                                    ST_Ymin(the_geom) as ymin
                                    FROM bbox`
		)
		.then((res) => {
			let geoJson = null;
			if (res.data.features.length > 1) {
				let aux = [];
				res.data["features"].forEach((elem, index) => {
					aux[index] = elem.properties;
				});
				let xmin = aux[0].xmin;
				let xmax = aux[0].xmax;
				let ymin = aux[0].ymin;
				let ymax = aux[0].ymax;
				aux.forEach((item, index) => {
					if (xmin > aux[index].xmin) {
						xmin = aux[index].xmin;
					}
					if (xmax < aux[index].xmax) {
						xmax = aux[index].xmax;
					}
					if (ymin > aux[index].ymin) {
						ymin = aux[index].ymin;
					}
					if (ymax < aux[index].ymax) {
						ymax = aux[index].ymax;
					}
				});
				geoJson = {properties: {xmin: xmin, xmax: xmax, ymin: ymin, ymax: ymax}};
			} else {
				geoJson = res.data["features"][res.data["features"].length - 1];
			}
			setMapViewBounds(geoJson);
		});
}

export function drawCartoPolygons(cartodbIds) {
	removeGeoJsonLayer();
	cartoDB
		.executeQueryWithBounds(`SELECT * FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds})`)
		.then((res) => {
			showGeoJSONData(res["data"]);
			fitBoundGeoJson(cartodbIds);
		})
		.catch((err) => {
			throw new Error(err);
		});
}
